import styled from '@emotion/styled';
import { ClassAttributes, createElement } from 'react';

type Props = ClassAttributes<HTMLElement> & {
  size?: number;
  className?: string;
};

const YouTubeIcon = ({ size, className }: Props) => (
  <Root xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size} className={className}>
    <path
      d="M22.5 6.7c-.3-1-1-1.7-1.9-2-1.7-.5-8.6-.5-8.6-.5s-6.9 0-8.6.5c-.9.3-1.7 1-1.9 2C1 8.4 1 12 1 12s0 3.6.5 5.3c.3 1 1 1.7 1.9 2 1.7.5 8.6.5 8.6.5s6.9 0 8.6-.5c.9-.3 1.7-1 1.9-2 .5-1.7.5-5.3.5-5.3s0-3.6-.5-5.3z"
      fill="#e70000"
    />
    <path fill="#fefefe" d="M9.8 15.3V8.7l5.7 3.3z" />
  </Root>
);

const Root = styled('svg')();

export default YouTubeIcon;
